module.exports = __webpack_public_path__ + "img/plane.91748e65.svg";